import { useCallback, useContext } from 'react';
import { consoleIfNotProd } from 'chatspot-core/loggers/consoleIfNotProd';
import { CopilotChannelContext } from '../CopilotChannelContext';
import { noopCopilotTelemetry } from '../../types/CopilotTelemetry';
export function useSendOnCopilotChannel(topic) {
  const {
    channel,
    telemetry = noopCopilotTelemetry
  } = useContext(CopilotChannelContext);
  return useCallback(data => {
    telemetry.channelMessageSent({
      topicName: topic,
      channelReady: Boolean(channel)
    });
    if (!channel) {
      consoleIfNotProd.error(`Channel not found.  Are you trying to send a message on the copilot channel outside of <CopilotProvider/>?`);
      return;
    }
    channel.postToTopic(topic, data);
  }, [channel, topic, telemetry]);
}